<template>
  <li :class="readClass" class="message" @click="$emit('clicked-message', message.MessageId)">
    <div v-if="!message.IsRead" class="unread-badge"></div>
    <h4 class="title">{{message.Title}}</h4>
    <p class="text">{{message.PreviewText}}</p>
    <p class="date">{{timeSince}}</p>
    <div class="delete-button" @click.stop="$emit('delete-message', message.MessageId)">
      <svg class="trash-can" viewBox="0 0 70 70" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- eslint-disable-line  -->
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M57.074,9.274 C59.625,9.274 61.613,11.263 61.613,13.813 L61.613,21.239 L57.711,21.239 L57.711,63.501 C57.711,66.052 55.727,68.001 53.176,68.001 L17.438,68.001 C14.887,68.001 12.938,66.052 12.938,63.501 L12.938,21.239 L9,21.239 L9,13.813 C9,11.263 10.988,9.274 13.539,9.274 L22.461,9.274 L22.461,3.501 C22.461,2.337 23.363,1.438 24.523,1.438 L45.711,1.438 C45.75,1.438 45.824,1.477 45.863,1.513 C45.898,1.477 45.973,1.438 46.086,1.438 C47.25,1.438 48.188,2.337 48.188,3.501 L48.188,9.274 L57.074,9.274 Z M26.586,9.274 L44.023,9.274 L44.023,5.563 L26.586,5.563 L26.586,9.274 Z M53.551,63.501 L53.551,21.239 L17.062,21.239 L17.062,63.501 C17.062,63.763 17.176,63.876 17.438,63.876 L53.176,63.876 C53.438,63.876 53.551,63.763 53.551,63.501 Z M57.449,17.114 L57.449,13.813 C57.449,13.552 57.336,13.399 57.074,13.399 L13.539,13.399 C13.273,13.399 13.164,13.552 13.164,13.813 L13.164,17.114 L57.449,17.114 Z M42.863,60.2 L42.863,26.075 L47.023,26.075 L47.023,60.2 L42.863,60.2 Z M33.262,60.2 L33.262,26.075 L37.426,26.075 L37.426,60.2 L33.262,60.2 Z M23.664,60.2 L23.664,26.075 L27.824,26.075 L27.824,60.2 L23.664,60.2 Z" id="Combined-Shape" fill="#000000"></path> <!-- eslint-disable-line -->
        </g>
      </svg>
    </div>
  </li>
</template>

<script>
import { formatDistance } from 'date-fns';
import { convertToLocal } from '../../utils/date';

export default {
  name: 'Listitem',
  props: {
    message: {
      type: Object,
    },
    locale: {
      type: Object,
    },
  },
  computed: {
    timeSince() {
      return formatDistance(
        convertToLocal(this.message.Date),
        new Date(),
        {
          locale: this.locale,
          addSuffix: true,
        },
      );
    },
    readClass() {
      if (this.message && this.message.IsRead) return 'is_read';
      return 'is_unread';
    }
  },
};
</script>

<style lang="less">
</style>
